import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  CardsContainer,
  Card,
  Feather,
  Name,
  Flip,
  Front,
  Back,
  TitleContainer,
  Description
} from './styled';

const ValueCard = ({
  id,
  name,
  description,
  frontBg,
  backBg,
  length,
  cardWidth,
  marginRight
}) => {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <Card
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
      cardWidth={cardWidth}
      marginRight={marginRight}
    >
      <Flip
        animate={{ rotateY: isFlipped ? 180 : 0 }}
        transition={{
          type: 'spring',
          mass: 2.9,
          damping: 21
        }}
      >
        <Front frontBg={frontBg}>
          <Feather />
          <Name>{name}</Name>
        </Front>

        <Back backBg={backBg}>
          <TitleContainer>
            <span>
              {id}/{length}
            </span>
            <h3>{name}</h3>
          </TitleContainer>
          <Description>{description}</Description>
        </Back>
      </Flip>
    </Card>
  );
};

const ValueCardsDesktop = ({ values }) => {
  const [cardsOffset, setCardsOffset] = useState(0);
  const cardWidth = 260;
  const marginRight = 60;

  const getCardsOffset = () => {
    const widthSum = cardWidth * values.length;
    const marginSum = marginRight * values.length;

    const offset = widthSum + marginSum;

    return offset;
  };

  useEffect(() => {
    setCardsOffset(getCardsOffset());
  }, []);

  return (
    <Wrapper maxWidth={cardsOffset}>
      <CardsContainer offset={cardsOffset}>
        {values.map((value) => (
          <ValueCard
            key={value.id}
            id={value.id}
            isBeAuthentic={value.id === 2}
            isDareToMakeMistakes={value.id === 7}
            name={value.name}
            description={value.description}
            frontBg={value.frontBg}
            backBg={value.backBg}
            length={values.length}
            cardWidth={cardWidth}
            marginRight={marginRight}
          />
        ))}
      </CardsContainer>
      <CardsContainer offset={cardsOffset}>
        {values.map((value) => (
          <ValueCard
            key={value.id}
            id={value.id}
            isBeAuthentic={value.id === 2}
            isDareToMakeMistakes={value.id === 7}
            name={value.name}
            description={value.description}
            frontBg={value.frontBg}
            backBg={value.backBg}
            length={values.length}
            cardWidth={cardWidth}
            marginRight={marginRight}
          />
        ))}
      </CardsContainer>
    </Wrapper>
  );
};

export default ValueCardsDesktop;

ValueCardsDesktop.propTypes = {
  values: PropTypes.array.isRequired
};

ValueCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cardWidth: PropTypes.number.isRequired,
  marginRight: PropTypes.number.isRequired,
  frontBg: PropTypes.string,
  backBg: PropTypes.string,
  id: PropTypes.number,
  length: PropTypes.number
};
